<template>
  <div :class="{ hidden: !menuShow }" class="menu">
    <div
      class="mx-auto flex w-full max-w-[1440px] flex-row items-center justify-between py-4 sm:p-0"
    >
      <router-link to="/" v-if="not_allowed !== 'true'">
        <img :src="logos[mode]" class="logo" alt="" />
      </router-link>
      <a :href="projectLink" v-if="not_allowed === 'true'">
        <img :src="logos[mode]" class="logo" alt="" />
      </a>
      <div class="burger_wrapper ml-auto mr-[1px] gap-x-3">
        <div
          v-if="mode === 'dark'"
          @click="mainStore.update('light')"
          class="mode_toggler max-sm:hidden"
        >
          <ModeLightIcon />
          <span class="text-[14px] leading-[142%] text-white sm:text-[20px] sm:leading-[22px]"
            >Light</span
          >
        </div>
        <div
          v-if="mode === 'light'"
          @click="mainStore.update('dark')"
          class="mode_toggler max-sm:hidden"
        >
          <ModeDarkIcon />
          <span class="text-background text-[14px] leading-[142%] sm:text-[20px] sm:leading-[22px]"
            >Dark</span
          >
        </div>
        <LanguageSwitcher />
        <router-link
          v-if="isLoggedIn"
          to="/account/ridehistory"
          class="button [word-break:_break-word]"
        >
          My Account
        </router-link>
        <template v-if="isMobile">
          <router-link
            v-if="!isLoggedIn && !isRegistrationPage"
            to="/registration/details"
            class="button [word-break:_break-word] md:!bg-[#3D4043] md:text-[#FFFFFF]"
            >Sign up</router-link
          >
          <router-link
            v-if="!isLoggedIn && isRegistrationPage"
            to="/account/signin"
            class="button [word-break:_break-word]"
            >Sign in</router-link
          >
        </template>
      </div>
      <div class="menu_close" @click="toggleAccordion">
        <TimesMobileIcon v-if="isMobile" />
        <TimesIcon v-if="!isMobile" />
      </div>
    </div>
    <div
      class="mx-auto mt-[110px] flex w-full max-w-[1440px] flex-col items-center justify-between md:flex-row xl:mt-[98px]"
    >
      <div
        class="menu_hover mb-[64px] flex w-full flex-col items-start justify-between xl:mb-0 xl:w-[65%]"
      >
        <a
          v-for="(item, index) in menuItems"
          :key="index"
          :href="item.url"
          :class="[activeIndex === index ? 'text-placeholder' : '', item.class]"
          @mousemove="handleMouseMove(index)"
          @mouseleave="handleMouseLeave"
        >
          {{ item.text }}
        </a>
      </div>
      <ContactInfo />
    </div>
    <div
      v-if="mode === 'dark'"
      @click="mainStore.update('light')"
      class="bg-background flex cursor-pointer justify-center gap-x-1.5 rounded-full p-3.5 sm:hidden"
    >
      <ModeLightIcon class="size-5" />
      <span class="text-[14px] leading-[142%] text-white">Light</span>
    </div>
    <div
      v-if="mode === 'light'"
      @click="mainStore.update('dark')"
      class="flex cursor-pointer justify-center gap-x-1.5 rounded-full bg-[#E8EDE8] p-3.5 sm:hidden"
    >
      <ModeDarkIcon class="size-5" />
      <span class="text-background text-[14px] leading-[142%]">Dark</span>
    </div>
  </div>
  <div class="flex w-full flex-row items-center justify-between py-4 sm:p-0">
    <router-link to="/" v-if="not_allowed != 'true'" class="shrink-0">
      <img :src="logos[mode]" class="logo" alt="" />
    </router-link>
    <a :href="projectLink" v-if="not_allowed == 'true'" class="shrink-0">
      <img :src="logos[mode]" class="logo" alt="" />
    </a>
    <nav class="hidden flex-row items-center justify-between xl:flex">
      <a
        :key="index"
        v-for="(link, index) in links"
        target="_blank"
        :href="link.url"
        class="menu__item mr-[48px]"
        >{{ link.title }}</a
      >
    </nav>

    <div class="burger_wrapper gap-x-3">
      <div
        v-if="mode === 'dark'"
        @click="mainStore.update('light')"
        class="mode_toggler max-sm:hidden"
      >
        <ModeLightIcon />
        <span class="text-[14px] leading-[142%] text-white sm:text-[20px] sm:leading-[22px]"
          >Light</span
        >
      </div>
      <div
        v-if="mode === 'light'"
        @click="mainStore.update('dark')"
        class="mode_toggler max-sm:hidden"
      >
        <ModeDarkIcon />
        <span class="text-background text-[14px] leading-[142%] sm:text-[20px] sm:leading-[22px]"
          >Dark</span
        >
      </div>
      <LanguageSwitcher />
      <router-link
        v-if="isLoggedIn"
        to="/account/ridehistory"
        class="button [word-break:_break-word]"
      >
        My Account
      </router-link>
      <template v-if="isMobile">
        <router-link
          v-if="!isLoggedIn && !isRegistrationPage"
          to="/registration/details"
          class="button [word-break:_break-word] md:!bg-[#3D4043] md:text-[#FFFFFF]"
          >Sign up</router-link
        >
        <router-link
          v-if="!isLoggedIn && isRegistrationPage"
          to="/account/signin"
          class="button [word-break:_break-word]"
          >Sign in</router-link
        >
      </template>
      <template v-else>
        <router-link
          v-if="!isLoggedIn"
          to="/registration/details"
          class="button [word-break:_break-word] md:!bg-[#3D4043] md:text-[#FFFFFF]"
          >Sign up</router-link
        >
        <router-link v-if="!isLoggedIn" to="/account/signin" class="button [word-break:_break-word]"
          >Sign in</router-link
        >
      </template>
      <BurgerIcon @click="toggleAccordion" />
    </div>
  </div>
</template>
<script setup>
import darklogo from '~project_assets/images/logo.png'
import lightlogo from '~project_assets/images/logo-light.png'
import { ref, reactive, inject, onBeforeMount, onMounted, computed } from 'vue'
import { useMainStore } from '@/stores'
import { storeToRefs } from 'pinia'
import { useMobile } from '@/compose/ismobile'
import ModeLightIcon from '@/components/ui/icons/ModeLightIcon.vue'
import ModeDarkIcon from '@/components/ui/icons/ModeDarkIcon.vue'
import ContactInfo from '@/blocks/ContactInfo.vue'
import BurgerIcon from '@/components/ui/icons/BurgerIcon.vue'
import TimesMobileIcon from '@/components/ui/icons/TimesMobileIcon.vue'
import TimesIcon from '@/components/ui/icons/TimesIcon.vue'
import { useUserStore } from '@/stores/user'
import { Dropdown } from 'flowbite'
import { useRoute, useRouter } from 'vue-router'
import LanguageSwitcher from '@/components/ui/utils/LanguageSwitcher.vue'

const mainStore = useMainStore()
const userStore = useUserStore()
const { isLoggedIn } = storeToRefs(userStore)
const storage = inject('storage')

const projectLink = ref(import.meta.env.VITE_PROJECT_URL)

const { mode } = storeToRefs(mainStore)

let not_allowed = storage.getItem('not_allowed', 'session')

let menuShow = ref(false)
let logos = reactive({
  light: lightlogo,
  dark: darklogo
})
const route = useRoute()
const { isMobile } = useMobile()
const isRegistrationPage = computed(() => route.path === '/registration/details')
const toggleAccordion = () => {
  if (menuShow.value === true) {
    document.body.classList.remove('overflow-hidden')
    document.body.classList.add('overflow-auto')
  } else {
    document.body.classList.remove('overflow-auto')
    document.body.classList.add('overflow-hidden')
  }
  menuShow.value = !menuShow.value
}

const activeIndex = ref(null)

const handleMouseMove = (index) => {
  activeIndex.value = index
}

const handleMouseLeave = () => {
  activeIndex.value = null
}

const links = []
const menuItems = []

onBeforeMount(() => {
  if (import.meta.env.VITE_PROJECT_ALIAS === 'dli') {
    links.push({
      title: 'About Us',
      url: projectLink.value + 'about-us/'
    })
    links.push({
      title: 'Limo Service',
      url: projectLink.value + 'services/limo-service/'
    })
    links.push({
      title: 'Italy Tours',
      url: projectLink.value + 'italy-tours/'
    })
    links.push({
      title: 'B2B',
      url: projectLink.value + 'b2b/'
    })

    menuItems.push({
      text: 'Fleet',
      url: projectLink.value + 'fleet/',
      class: 'menu_title mt-0 pb-6 xl:pb-[48px]'
    })
    menuItems.push({
      text: 'Airport Transfers',
      url: projectLink.value + 'services/airport-transfers/',
      class: 'menu_title mt-0 pb-6 xl:pb-[48px]'
    })
    menuItems.push({
      text: 'Gems of Italy',
      url: projectLink.value + 'blog/',
      class: 'menu_title mt-0 pb-6 xl:pb-[48px]'
    })
    menuItems.push({
      text: 'Contact Us',
      url: projectLink.value + 'contact/',
      class: 'menu_title mt-0'
    })
  }

  if (import.meta.env.VITE_PROJECT_ALIAS === 'rlt') {
    links.push({
      title: 'About Us',
      url: projectLink.value + 'about-us/'
    })
    links.push({
      title: 'Limo Service',
      url: projectLink.value + 'rome-limousine-service/'
    })
    links.push({
      title: 'Chauffeur Service',
      url: projectLink.value + 'rome-chauffeur-service/'
    })
    links.push({
      title: 'Private Driver',
      url: projectLink.value + 'rome-private-driver/'
    })

    menuItems.push({
      text: 'Fleet',
      url: projectLink.value + 'fleet/',
      class: 'menu_title mt-0 pb-6 xl:pb-[48px]'
    })
    menuItems.push({
      text: 'Rome Car Service',
      url: projectLink.value + 'rome-car-service/',
      class: 'menu_title mt-0 pb-6 xl:pb-[48px]'
    })
    menuItems.push({
      text: 'B2B',
      url: projectLink.value + 'b2b/',
      class: 'menu_title mt-0 pb-6 xl:pb-[48px]'
    })
    menuItems.push({
      text: 'Contact Us',
      url: projectLink.value + 'contact/',
      class: 'menu_title mt-0'
    })
  }

  if (import.meta.env.VITE_PROJECT_ALIAS === 'dgt') {
    links.push({
      title: 'About Us',
      url: projectLink.value + 'about-us/'
    })
    links.push({
      title: 'Private tours',
      url: projectLink.value + 'tuscany-private-tours/'
    })
    links.push({
      title: 'Chauffeur Service',
      url: projectLink.value + 'tuscany-chauffeur-service/'
    })
    links.push({
      title: 'B2B',
      url: projectLink.value + 'b2b/'
    })

    menuItems.push({
      text: 'Fleet',
      url: projectLink.value + 'our-fleet/',
      class: 'menu_title mt-0 pb-6 xl:pb-[48px]'
    })
    menuItems.push({
      text: 'Airport Transfers',
      url: projectLink.value + 'transfers/',
      class: 'menu_title mt-0 pb-6 xl:pb-[48px]'
    })
    menuItems.push({
      text: 'Contact Us',
      url: projectLink.value + 'contacts/',
      class: 'menu_title mt-0 pb-6 xl:pb-[48px]'
    })
  }
})

const router = useRouter()

onMounted(() => {
  router.beforeEach((to, from, next) => {
    if (menuShow.value) {
      toggleAccordion()
    }
    next()
  })
  const languagesTriggers = document.querySelectorAll('.languagesTrigger')
  const languagesElements = document.querySelectorAll('.languages')
  let dropdownInstances

  const getLastSelectedLanguage = () => {
    return document.cookie
      .split(';')
      .find((elem) => {
        return elem.includes('googtrans')
      })
      ?.slice(-2)
  }

  window.languageSwitcherElementInit = () => {
    const pageLanguage = getLastSelectedLanguage() || 'en'
    const includedLanguages = ['it', 'en']

    new window.google.translate.TranslateElement(
      { pageLanguage: null, includedLanguages: includedLanguages.join(',') },
      'languageSwitcherElement'
    )

    const googTeComboSelect = document.querySelector('.goog-te-combo')
    const currentLanguageElements = document.querySelectorAll('.currentLanguage')
    let languagesButtons
    const highlightColor = ['text-[#A3B4A3]', 'dark:text-main', 'cursor-default']

    const changeCurrentLanguageElementsValue = (text) => {
      currentLanguageElements.forEach((element) => {
        element.textContent = text
      })
    }

    languagesElements.forEach((languagesElement) => {
      includedLanguages.forEach((language) => {
        languagesElement.insertAdjacentHTML('beforeend', `<button>${language}</button>`)
      })
    })

    languagesButtons = document.querySelectorAll('.languages button')

    languagesButtons.forEach((button) => {
      changeCurrentLanguageElementsValue(pageLanguage)

      if (button.textContent === pageLanguage) {
        button.classList.add(...highlightColor)
      }

      button.addEventListener('click', () => {
        const clickedButton = button

        if (clickedButton.textContent !== googTeComboSelect.value) {
          changeCurrentLanguageElementsValue(clickedButton.textContent)

          googTeComboSelect.value = clickedButton.textContent
          googTeComboSelect.dispatchEvent(new Event('change'))

          // $.datetimepicker.setLocale(button.textContent);

          languagesButtons.forEach((button) => {
            if (clickedButton.textContent === button.textContent) {
              button.classList.add(...highlightColor)
            } else {
              button.classList.remove(...highlightColor)
            }
          })

          for (const key in dropdownInstances) {
            dropdownInstances[key].hide()
          }
        }
      })
    })
  }

  new Dropdown(languagesElements[0], languagesTriggers[0])
  new Dropdown(languagesElements[1], languagesTriggers[1])

  dropdownInstances = window.FlowbiteInstances.getInstances('Dropdown')

  const script = document.createElement('script')
  script.src = '//translate.google.com/translate_a/element.js?cb=languageSwitcherElementInit'
  document.head.appendChild(script)
})
</script>
